import { render, staticRenderFns } from "./SlackChannelPicker.vue?vue&type=template&id=d623db2e&"
import script from "./SlackChannelPicker.vue?vue&type=script&lang=js&"
export * from "./SlackChannelPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports